import { render, staticRenderFns } from "./ModalBillExchange.vue?vue&type=template&id=2decc18e&"
import script from "./ModalBillExchange.vue?vue&type=script&lang=js&"
export * from "./ModalBillExchange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports